define(["exports", "./utils", "jquery"], function (_exports, _utils, _jquery) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.name = void 0;
  _jquery = _interopRequireDefault(_jquery);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  // @ts-check
  const name = "core/jquery-enhanced";
  _exports.name = name;
  window.$ = window.jQuery = _jquery.default; // --- JQUERY EXTRAS -----------------------------------------------------------------------
  // Applies to any jQuery object containing elements, changes their name to the one give, and
  // return a jQuery object containing the new elements

  window.$.fn.renameElement = function (name) {
    const arr = []; // @ts-ignore

    this.each(function () {
      // @ts-ignore
      const elem = this;
      const newElem = (0, _utils.renameElement)(elem, name);
      arr.push(newElem);
    });
    return (0, _jquery.default)(arr);
  }; // For any element, returns an array of title strings that applies
  // the algorithm used for determining the
  // actual title of a <dfn> element (but can apply to other as well).
  //
  // if args.isDefinition is true, then the element is a definition, not a
  // reference to a definition.  Any @title or @lt will be replaced with
  // @data-lt to be consistent with Bikeshed / Shepherd.
  //
  // This method now *prefers* the data-lt attribute for the list of
  // titles.  That attribute is added by this method to dfn elements, so
  // subsequent calls to this method will return the data-lt based list.
  //
  // This method will publish a warning if a title is used on a definition
  // instead of an @lt (as per specprod mailing list discussion).


  window.$.fn.getDfnTitles = function () {
    return (0, _utils.getDfnTitles)(this[0]);
  }; // For any element (usually <a>), returns an array of targets that
  // element might refer to, of the form
  // {for: 'interfacename', title: 'membername'}.
  //
  // For an element like:
  //  <p link-for="Int1"><a for="Int2">Int3.member</a></p>
  // we'll return:
  //  * {for: "int2", title: "int3.member"}
  //  * {for: "int3", title: "member"}
  //  * {for: "", title: "int3.member"}


  window.$.fn.linkTargets = function () {
    return (0, _utils.getLinkTargets)(this[0]);
  }; // Applied to an element, sets an ID for it (and returns it), using a specific prefix
  // if provided, and a specific text if given.


  window.$.fn.makeID = function (pfx = "", txt = "", noLC = false) {
    const elem = this[0];
    return (0, _utils.addId)(elem, pfx, txt, noLC);
  }; // Returns all the descendant text nodes of an element. Note that those nodes aren't
  // returned as a jQuery array since I'm not sure if that would make too much sense.


  window.$.fn.allTextNodes = function (exclusions) {
    return (0, _utils.getTextNodes)(this[0], exclusions);
  };
});
//# sourceMappingURL=jquery-enhanced.js.map